module.exports = __webpack_public_path__ + "img/status4.e01eb4ed.gif";